import { css } from 'styled-components';

const ClearFixStyle = css`
  &::after {
    content: '.';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
`;

export default ClearFixStyle;
